<template>
  <div :class="['upload_proof', loading ? 'disabled' : '']">
    <div class="main">
      <div class="btn-requirement" @click="onClickRequirement">?</div>
      <div class="article-info">
        <div class="one" v-if="topicInfo.topic_list && topicInfo.topic_list.length === 1">
          <div class="title">{{ topicInfo.topic_list[0].title }}</div>
          <div class="sub-title">{{topicInfo.group_name}}</div>
        </div>
        <div class="two" v-if="topicInfo.topic_list && topicInfo.topic_list.length >= 2">
          <div class="title">{{topicInfo.group_name}}</div>
          <ul>
            <li v-for="(item, index) in topicInfo.topic_list" :key="item.id" :class="{'active':index === checkIndex }" @click='toggle(index)'>
              <span>{{item.title}}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="main_upload">
        <van-form
          class="apply-content"
        >
          <van-field
            v-model="form.title"
            required
            name="题目"
            label="题目"
            placeholder="请输入您的作文题目"
            maxlength="20"
            minlength="1"
            class="topic-input"
            :formatter="formatter"
          ></van-field>
          <div class="province_picker">
            <van-field
              readonly
              clickable
              label="省份"
              placeholder="请选择您所在的省份"
              :value="form.province_name"
              :error-message="errMsg.province_name"
              @click="showProvincePicker"
              :rules="[{ trigger: 'onSubmit' }]"
            />
            <div class="left_icon"></div>
          </div>
          <!-- {{form.preImgArr}} -->
          <div class="upload" @click="clickUpload">
            <div class="upload_item card">
              <div class="label">上传作文图片</div>
              <div :class="['upload_img', { upload_error: errMsg.idCardImg }]">
                <van-uploader
                  v-model="form.preImgArr"
                  :after-read="afterReadImage"
                  multiple
                  :show-upload="form.preImgArr.length < 4"
                  :before-read="beforeRead"
                  accept="image/* video/*"
                />
                <p class="tip" v-if="form.preImgArr.length === 0">点击上传图片</p>
              </div>
              <div class="error_tip">{{ errMsg.idCardImg }}</div>
            </div>
          </div>
        </van-form>
         <div class="upload-tip">
        <p>建议使用稿纸写作，拍照上传，详情参见<span class="btn-photo" @click="onPreview">「拍照样例」</span></p>
        <p>最多支持上传4张图片，请注意图片规范哦~</p>
      </div>
      <div class="btn-wrapper">
        <button
          class="submit-btn"
          @click="addInfo"
          ref="pStyle"
         :class="['submit-btn', canSubmit ? 'submit-btn-active' : 'submit-btn-unActive']"
         :disabled="!canSubmit"
        >提交</button>
      </div>
      </div>
      <ProvincePicker ref="provincePicker" @setLocation="handleSetLocation"/>
      <writing-requirement ref="writingRequirement" :topicInfo="topicInfo"/>
    </div>
    <van-overlay :show="loading">
      <van-loading class="loading" v-if="loading" />
    </van-overlay>
  </div>
</template>

<script>
// import TSS from '@xes/dh-hippo-jssdk'
import TSS from '@xes/xes-oss-jssdk'
import ProvincePicker from '../../components/provincePicker'
import WritingRequirement from '../home/components/common/writingRequirement'
import area from '../../components/provincePicker/config/area'
import { Dialog, ImagePreview, Toast } from 'vant'
import previewImg from '@/summerCamp/assets/images/upload/demo.png'
import Compressor from 'compressorjs'

export default {
  name: 'uploadProof',
  components: {
    ProvincePicker,
    WritingRequirement
  },
  data() {
    return {
      pageuid: 'activitiesPage3',
      phone: '',
      hasUploadSuccess: true,
      form: {
        title: '', // 作文题目
        topic_id: '', // 命题id
        province_id: '', // 省份id
        province_name: '', // 省份名称
        preImgArr: [], // 作文图片
        artical_image: [] // 作文图片上传oss后拿到的url集合
      },
      artical_image: [], // 作文图片上传oss后拿到的url集合
      canSubmit: false,
      loading: false,
      errMsg: {
        title: ''
      },
      errMsgConfig: {
        title: '输入1-20个字的有效字符'
      },
      disabled: false, // 提交按钮的默认态
      topicInfo: {},
      groupName: '',
      checkIndex: 0,
      retryTimes: 1
    }
  },
  watch: {
    form: {
      handler(val) {
        this.canSubmit = val.title && val.province_id && val.preImgArr.length
      },
      deep: true
    }
  },
  mounted() {
    this.init()
    this.getArticalTopic()
  },
  methods: {
    /**
     * 页面初始化
    */
    async init() {
      // this.checkLogin()
    },
    beforeRead(files) {
      const toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '图片处理中...'
      })

      return new Promise((resolve) => {
        resolve(files)
        toast.clear()
      })
    },
    async getArticalTopic() {
      const res = await this.$api.articalTopic()
      const data = res && res.data
      if (+res.code === 0 && data && data.topic_list) {
        const { topic_list, group_name } = data
        this.topicInfo = {
          topic_list,
          group_name
        }
        this.form.topic_id = topic_list[0].id
      }
    },
    /**
       * 检测登陆态： 目的获取用户手机号
       */
    async checkLogin() {
      const res = await this.$api.checkLogin()
      if (res.code === 1105) {
        this.$router.replace({
          name: 'home'
        })
      }
    },
    /**
       * 作文图片 读取完毕
       * @param file
       */
    async afterReadImage() {
      if (this.form.preImgArr.length > 4) {
        this.$toast('最多支持上传4张图片')
        this.form.preImgArr = this.form.preImgArr.slice(0, 4)
      }
      this.$xesLogger.clickMsg({
        params: { clickid: '11.0.3', elemname: '点击添加作文图片' }
      })
    },
    /**
     * 提交前的表单校验
     */
    validatorSubmit(item) {
      const form = this.form
      if (!form[item]) {
        this.errMsg[item] = this.errMsgConfig[item]
        return false
      } else {
        return true
      }
    },
    formatter(value) {
      const regRule = /[^\u4E00-\u9FA5|\d|a-zA-Z|\r\n\s,.?!，“”。；#%-_：《》<>？！…—&$=()-+/*{}[\]]/g
      return value.replace(regRule, '')
    },
    async addInfo() {
      this.$xesLogger.clickMsg({
        params: { clickid: '11.0.5', elemname: '点击提交作文按钮' }
      })
      if (!this.form.title.replace(/^\s+|\s+$/g, '')) {
        this.$toast(this.errMsg.title)
        return
      }
      if (!this.validatorSubmit('province_name')) {
        this.$toast('请选择省份')
        return
      }

      if (this.form.preImgArr.length === 0) {
        this.$toast('请上传作文图片')
        return
      }

      this.$xesAlert({
        type: 'confirm',
        message: '<div>提交信息后不可修改</div><div>确认填写信息无误</div>',
        sureText: '确认',
        cancelText: '取消',
        onSure: () => {
          this.onSubmit()
        },
        onCancel: () => {
          this.canSubmit = true
          this.loading = false
        }
      })
    },
    async onSubmit() {
      this.canSubmit = false
      this.loading = true
      await this.uploadOSS(this.invokeSubmit)
    },
    async invokeSubmit() {
      const { topic_id, title, province_id, province_name } = this.form
      const params = {
        title,
        topic_id: +topic_id,
        province_id,
        province_name,
        artical_image: this.artical_image
      }

      const res = await this.$api.addInfo(params)
      this.hasUploadSuccess = true
      this.canSubmit = true
      this.loading = false
      if (res.code === 0) {
        this.checkReceiveCode(res.code, '您可返回首页查看作文审核状态\n审核通过后即可开始助力')
      } else {
        this.$toast(res.msg)
      }
    },
    checkReceiveCode(code, msg) {
      switch (Number(code)) {
        case 0:
          // 提交信息
          // this.$router.replace({
          //   name: 'submitSuccess'
          // })
          // this.$xesAlert({
          //   title: '提示',
          //   message: msg
          // })
          Dialog.alert({
            title: '提交成功',
            message: '您可返回首页查看作文审核状态\n审核通过后即可开始助力',
            theme: 'round-button',
            confirmButtonText: '返回首页'
          }).then(() => {
            this.$router.replace({
              path: '/'
            })
          })
          break
        default:
          this.$toast(msg || '请求错误')
          break
      }
    },
    clickUpload() {
      this.$xesLogger.clickMsg({
        params: {
          pageuid: this.pageuid,
          clickid: 1,
          action: 'click_upload_uv',
          clickname: '点击两个上传图片按钮中任意一个按钮'
        }
      })
    },
    handleSetLocation(data) {
      this.form.province_name = data.name
      this.form.province_id = +area[data.name].val
    },
    showProvincePicker() {
      this.$refs.provincePicker.visible = true
      this.$xesLogger.clickMsg({
        params: { clickid: '11.0.6', elemname: '点击选省份' }
      })
    },
    // base64转文件流
    base64ToFile(urlData, fileName) {
      const arr = urlData.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bytes = atob(arr[1]) // 解码base64
      let n = bytes.length
      const ia = new Uint8Array(n)
      while (n--) {
        ia[n] = bytes.charCodeAt(n)
      }
      return new File([ia], fileName, { type: mime })
    },
    async uploadOSS(next) {
      this.hasUploadSuccess = false
      let data = {}
      if (process.env.NODE_ENV !== 'production') {
        data = {
          appId: '375be9962486fba23033c3750ce7cd94',
          appKey: '3a96a2c994c5e4c67ef61899a3327b27',
          token: '9272419af84816d750e549b484e27cbe:79ed71d7a61fc8d6fd1c8514f2d7ce43ad7e12b6:eyJidWNrZXQiOiJncm93dGgtaDUtZWRpdC1zdGFpb24iLCJleHBpcmF0aW9uIjoiMjAyMTA2MDZUMTU1NDExWiIsImtleSI6InBvc3RlcnVybFwvIiwidmVyc2lvbiI6IjEuMCJ9'
        }
      } else {
        data = await this.getuploadtoken()
      }
      console.log('getuploadtoken', data)
      this.artical_image.splice(0, this.artical_image.length)

      const promiseArr = this.form.preImgArr.map(async(item) => {
        const files = this.base64ToFile(item.content)
        const suffixArr = item.file.name.split('.')
        const suffix = suffixArr[1]
        return this.imgUpload(data, files, item.content, suffix)
      })

      return Promise.all(promiseArr).then(result => {
        console.log('上传oss成功', result)
        this.artical_image = result
        next && next()
      }).catch((info, err) => {
        if (this.retryTimes > 0) {
          --this.retryTimes
          this.onSubmit()
        } else {
          this.$toast('提交失败，请稍后再试')
          this.canSubmit = true
          this.loading = false
          this.retryTimes = 1
          console.error(err, '上传oss失败')
          this.$xesLogger.clickMsg({
            params: {
              clickid: '12.0.0',
              elemname: '上传oss error',
              info,
              err
            }
          })
          throw Error(err)
        }
      })
      // const list = await this.executePromises(promiseArr)
    },
    executePromises(createPromises) {
      let result = Promise.resolve()
      createPromises.forEach(function(createPromise) {
        result = result.then(createPromise)
      })
      return result
    },
    // 上传网校云
    async getuploadtoken() {
      const res = await this.$api.newGetUploadToken({
        keyword: 'posterurl'
      })

      if (res.code === 0 && res.data) {
        return res.data
      } else {
        console.error(res.msg)
      }
      this.$toast('上传失败，请稍后再试')
      throw Error('get upload token error')
    },
    imgUpload({ appId, appKey, token }, files, originFile, suffix) {
      const bucket = 'growth-h5-activity'
      return new Promise((resolve, reject) => {
        const filename = `000${Date.now()}.${suffix}`
        const name = encodeURIComponent(filename)
        const storage = new TSS.StorageClient({
          accessKeyId: appId,
          accessKeySecret: appKey,
          securityToken: token
        })
        storage.upload({
          headers: {
            'Content-Type': '*' // 可以设置image/jpeg，image/gif，*等
          },
          data: {
            body: files, // 上传的二进制文件
            bucket, // bucket name
            key: name, // 文件名称，可以携带具体文件夹，比如a/b/c.jpg
            checkMd5: false // 是否校验md5
          },
          success: (result) => {
            // 成功回调
            console.log(result)
            if (+result.status === 200) {
              const url =
                `https://static0.xesimg.com/${bucket}/${name}?pipeline=fm,jpg/q,50/size,w_750`
              console.log(url, '~~~~~')
              resolve(url)
            } else {
              reject(JSON.stringify({
                resultStatus: result.status,
                originFile
              }))
            }
          },
          fail: (err) => {
            // 失败回调
            reject(JSON.stringify({
              originFile
            }), err)
          }
        })
      })
    },
    onClickRequirement() {
      this.$refs.writingRequirement.visible = true
      this.$xesLogger.clickMsg({
        params: { clickid: '10.0.5', elemname: '点击写作要求' }
      })
    },
    toggle(index) {
      this.checkIndex = index
      this.form.topic_id = this.topicInfo.topic_list[index].id
    },
    onPreview() {
      ImagePreview({
        images: [
          previewImg
        ],
        showIndex: false,
        closeable: true,
        closeIconPosition: 'top-left'
      })
    }
  }
}
</script>
<style lang="less">
.upload_proof {
  min-height: 100vh;
  padding: 0 12px 0;
  overflow: hidden;
  font-size: 26/2px;
  font-weight: 400;
  font-family: PingFang SC Regular, PingFang SC Regular-Regular;
  line-height: 43/2px;
  color: #6d6963;
  background: linear-gradient(230deg, #fffaee 0%, #fff0da 100%);
  box-shadow: 0 0 24px 0 rgba(191, 191, 191, 0.31), 0 -1px 0 0 #f7f1e2;

  &.disabled {
    pointer-events: none;
  }

  .main {
    position: relative;
    min-height: calc(100vh - 48px);
    padding: 0 24px;
    margin-top: 16px;
    margin-bottom: 32px;
    overflow: hidden;
    background: #fff;
    border-radius: 8px;

    .btn-requirement {
      position: absolute;
      top: 12px;
      right: 12px;
      width: 16px;
      height: 16px;
      line-height: 16px;
      text-align: center;
      color: #fff;
      background: rgba(153, 153, 153, 0.47);
      border-radius: 50%;
    }

    .article-info {
      margin-top: 10px;
      text-align: center;

      .one {
        .title {
          height: 17px;
          margin-top: 20px;
          font-size: 17px;
          font-weight: 500;
          font-family: PingFangSC-Medium, PingFang SC;
          line-height: 17px;
          color: #333;
        }

        .sub-title {
          height: 13px;
          margin-top: 8px;
          font-size: 13px;
          font-weight: 400;
          font-family: PingFangSC-Regular, PingFang SC;
          line-height: 13px;
          color: #999;
        }
      }

      .two {
        .title {
          margin-top: 20px;
          margin-bottom: 16px;
          font-size: 17px;
          font-weight: 500;
          line-height: 17px;
          color: #333;
        }

        ul {
          display: flex;
          padding: 0 4px;

          li {
            position: relative;
            z-index: 1;
            flex: 1;
            height: 28px;
            padding: 0 17px;
            overflow: hidden;
            font-size: 13px;
            font-weight: 400;
            font-family: PingFangSC-Regular, PingFang SC;
            line-height: 13px;
            line-height: 28px;
            white-space: nowrap;
            color: #999;
            background: hsla(0, 0%, 60%, 0.1);
            border-radius: 14px;
            text-overflow: ellipsis;

            &.active {
              color: #e02727;
              background: rgba(224, 39, 39, 0.1);

              &::before {
                position: relative;
                top: 18%;
                display: inline-block;
                width: 6px;
                height: 11px;
                margin-right: 4px;
                color: #e02727;
                transform: translate(0, -50%) rotate(45deg);
                content: '';
                border-bottom: 1px solid;
                border-right: 1px solid;
              }
            }

            &:first-child {
              margin-right: 8px;
            }

            // > span {
            //   color: #e02727;
            // }
          }
        }
      }
    }

    .main_upload {
      padding: 0 0 100px;
      margin-top: 28px;

      .title {
        font-size: 30/2px;
        font-weight: 500;
        line-height: 50/2px;
        color: #e52c30;
      }

      .van-form {
        .province_picker {
          position: relative;

          .left_icon {
            position: absolute;
            top: 25px;
            right: 16px;
            width: 12px;
            height: 12px;
            background-image: url('../../assets/images/apply/left_icon.png');
            background-size: cover;
            background-repeat: no-repeat;
          }
        }

        .van-cell {
          padding: 10px 0;
        }

        .van-cell::after {
          border: none;
        }

        .van-cell--required::before {
          content: "";
        }

        .error {
          .van-field__value {
            border: 1px solid #e52c30;
          }
        }

        .van-field {
          margin: 6px 0;

          .van-field__label {
            width: 30px;
            height: 80/2px;
            font-size: 30/2px;
            font-weight: 500;
            line-height: 80/2px;
            white-space: nowrap;
            color: #666;
          }

          .van-field__value {
            height: 80/2px;
            padding: 0 29/2px;
            font-size: 28/2px;
            line-height: 80/2px;
            background: #f8f6f9;
            border-radius: 20px;

            .van-field__error-message {
              font-size: 30/2px;
              line-height: 1;
            }
          }
        }

        .upload {
          display: flex;

          .upload_item {
            flex: 1;

            .label {
              height: 13px;
              margin: 18px 0 16px;
              font-size: 13px;
              font-weight: 400;
              font-family: PingFangSC-Regular, PingFang SC;
              line-height: 13px;
              color: #333;
            }

            .upload_img {
              text-align: left;

              .van-uploader {
                width: 100%;
                text-align: center;
              }

              .van-uploader__upload {
                width: calc(98% / 2);
                height: 148px;
                margin-right: 0 !important;
                background: #fff;
                border: 1px solid #efefef;
                border-radius: 7px;
              }

              .van-uploader__preview-image {
                width: 100%;
                height: 148px;
                margin: 0;
              }

              .van-uploader__preview {
                width: calc(98% / 2);
                height: calc(98% / 2);
                margin-right: 2%;
                margin-bottom: 2%;

                &:nth-of-type(2n) {
                  margin-right: 0;
                }
              }

              .van-uploader__wrapper {
                .van-uploader__preview {
                  float: left;
                }
              }

              .van-uploader__preview-delete {
                background-color: #e02727;
                border-radius: 50%;
                transform: translate3d(50%, -50%, 0);

                &::before {
                  font-size: 50/2px;
                }
              }

              .van-uploader__preview-delete-icon {
                top: -1px;
                right: -1px;
              }

              .tip {
                margin-top: 3px;
                font-size: 24/2px;
                font-weight: 500;
                color: #999;
              }
            }

            .upload_error {
              border: 1px dotted #e52c30;
            }

            .error_tip {
              text-align: center;
              color: #e52c30;
            }
          }

          .card {
            .van-icon-photograph::before {
              width: 231/2px;
              height: 174/2px;
              line-height: 174/2px;
              background-color: white;
              background-size: cover;
            }
          }
        }
      }
    }

    .btn-wrapper {
      position: absolute;
      bottom: 28px;
      left: 50%;
      transform: translateX(-50%);

      .submit-btn {
        width: 232px;
        height: 40px;
        margin: 16px auto 0;
        font-size: 15px;
        font-weight: 400;
        color: #fff;
        background: #e02727;
        border-radius: 23px;

        &-active {
          color: #fff;
          background: #e02627;
        }

        &-unActive {
          color: #999;
          background: rgba(153, 153, 153, 0.1);
        }
      }
    }

    .upload-tip {
      width: 315px;
      height: 36px;
      margin-top: 16px;
      font-size: 13px;
      font-weight: 400;
      font-family: PingFangSC-Regular, PingFang SC;
      line-height: 18px;
      color: #999;

      .btn-photo {
        font-weight: bold;
        color: #e02727;
      }
    }
  }
}

</style>
<style lang="less" scoped>
/deep/ .van-overlay {
  background-color: rgba(0, 0, 0, 0.5);
}

.apply-content /deep/ .van-field__body {
  height: 100%;
}

.apply-content /deep/ .van-field__body input {
  line-height: normal;
}

.apply {
  min-height: 100vh;
  padding-top: 124px;
  padding-bottom: 75px;
  background: red;

  .apply-content {
    position: relative;
    width: 351px;
    height: 525px;
    margin: auto;
    overflow: hidden;
    font-family: PingFangSC-Medium, PingFang SC;
    background: white;
    border-radius: 8px;

    .van-field__body {
      height: 100%;

      input {
        line-height: normal;
      }
    }

    .submit-btn {
      position: absolute;
      bottom: 28px;
      left: 50%;
      width: 232px;
      height: 40px;
      font-size: 15px;
      font-weight: 500;
      line-height: 40px;
      text-align: center;
      border-radius: 20px;
      transform: translateX(-50%);
    }

    .submit-btn-active {
      color: #fff;
      background: #e02627;
    }

    .submit-btn-unActive {
      color: #999;
      background: rgba(153, 153, 153, 0.1);
    }
  }
}

.loading {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
